import { render, staticRenderFns } from "./push_message.vue?vue&type=template&id=31f0466a&scoped=true&"
import script from "./push_message.vue?vue&type=script&lang=js&"
export * from "./push_message.vue?vue&type=script&lang=js&"
import style0 from "./push_message.vue?vue&type=style&index=0&id=31f0466a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0466a",
  null
  
)

export default component.exports